import { ReactElement, ReactNode, useState } from "react";
import PurchasePlanModal from "../../PurchasePlanModal";
import { PricingModelType } from "../../../model/pricingmodel";
import classnames from "classnames";

interface Props {
  children?: ReactNode;
  onSuccess: () => void;
  reload: () => void;
  triggerContainerClassName?: string;
  enable?: boolean;
  defaultOpen?: boolean;
  onClose?: () => void;
  dialogPortal?: (element: ReactElement) => ReactElement;
}

export default function PurchasePlanPaywall(props: Props) {
  const { children, reload, defaultOpen, onClose } = props;
  const [open, setOpen] = useState(false);
  // If defaultOpen is undefined or false - we must look at the locally stored "open" state.
  const shouldOpen = defaultOpen === true ? true : open;

  const hdClose = () => {
    setOpen(false);
    onClose?.();
  };

  const onSuccess = () => {
    setOpen(false);
    props.onSuccess();
  };

  const onOpen = () => {
    if (!props.enable) {
      return;
    }
    setOpen(true);
  };

  if (!shouldOpen) {
    return (
      <div
        className={classnames("trigger-modal-container", props.triggerContainerClassName)}
        onClick={onOpen}
      >
        {children}
      </div>
    );
  }

  let element = (
    <PurchasePlanModal
      backOptionsText={"Go back"}
      onClose={hdClose}
      onSuccess={onSuccess}
      reload={reload}
      type={PricingModelType.SELF_STUDY}
    />
  );
  if (props.dialogPortal) {
    element = props.dialogPortal(element);
  }

  return (
    <>
      <div
        className={classnames("trigger-modal-container", props.triggerContainerClassName)}
      >
        {children}
      </div>
      {element}
    </>
  );
}
